import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createI18n } from 'vue-i18n'
import App from './App.vue'
import router from './router'
import './assets/main.css'

// Create Vue app instance
const app = createApp(App)

// Create Pinia store
const pinia = createPinia()

// Create i18n instance with basic configuration
const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    en: {
      // Add translations as needed
    }
  }
})

// Use plugins
app.use(pinia)
app.use(router)
app.use(i18n)

// Global error handler
app.config.errorHandler = (err, instance, info) => {
  console.error('[Vue Error]', err, info)
}

// Mount app
app.mount('#app')

// Make app instance globally available for debugging
if (import.meta.env.DEV) {
  window.__VUE_APP__ = app
}
